import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonIcon, IonItem, IonLabel, IonList, IonMenuToggle } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { AccountService } from '@okcargo-apps/shared-application-ionic';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-menu-main',
  templateUrl: './menu-main.component.html',
  styleUrls: ['./menu-main.component.scss'],
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    IonList,
    IonItem,
    IonMenuToggle,
    IonIcon,
    IonLabel,
  ],
})
export class MenuMainComponent {
  private readonly accountService = inject(AccountService);

  public readonly userCapabilities$: Observable<ECapabilities[]> = this.accountService.userCapabilities$;
  public readonly ECapabilities = ECapabilities;

  // constructor() {}
}
